<template>
    <table class="table table-hover spacing-b-mobile table-striped">
        <thead style="background-color: #1c699d; color: white;">
            <th style="padding: 10px;width: 30%">TEXTO</th>
            <th class="text-center" v-if="! isMobile()" style="padding: 10px">DT CADASTRO</th>
            <th class="text-center" v-if="! isMobile()" style="padding: 10px">DT ENVIO</th>
            <th class="text-center">STATUS</th>
            <th class="text-center">ACÕES</th>
        </thead>
        <tbody>
            <tr v-for="u in cars">
                <td>{{u.texto | uppercase}}</td>
                <td v-if="! isMobile()" class="text-center">{{u.data_cadastro | date('DD-MM-YYYY HH:mm')}}</td>
                <td v-if="! isMobile()" class="text-center">{{u.data_conclusao | date('DD-MM-YYYY HH:mm')}}</td>
                <td class="text-center">{{u.status | uppercase}}</td>
                <td class="text-center">
                    <button type="button" @click="excluir(u.id_comandos)" class="btn btn-danger btn-xs">EXCLUIR</button>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
    import { date } from '../../filter';
    import { Comandos } from "../../class/comandos";
    import { Bus } from '../../class/bus';
    import { isMobile } from '../../utils/is-celular';
    export default {
        props : {
            id_rastreador: {
                "default": null
            }
        },
        filters: {
            date
        },
        data(){
            return {
                cars: [],
                interval: null
            }
        },
        methods: {
            isMobile() {
                return isMobile()
            },
            async load(){
                this.cars = await Comandos.last(this.id_rastreador);
            },
            async excluir (id) {
                await Comandos.excluir(id);
                await this.load();
            }
        },
        beforeMount () {
            this.load();
            this.interval = setInterval(() => this.load(), 30000);
            Bus.$on('comandos',this.load);
        },
        beforeDestroy () {
            Bus.$off('comandos',this.load);
            clearInterval(this.interval);
        }
    }
</script>
